module.exports = ($uibModalInstance, $scope, validationError) ->

  $scope.validationError = validationError

  $scope.close = ->
    $uibModalInstance.close()

  $scope.dismiss = ->
    $uibModalInstance.dismiss()

  # Not listening to click to allow for right clicks / shift to open in new window
  $scope.$on('$stateChangeStart', $scope.dismiss)
